export enum EntryType {
	Credit = "credit",
	Deduction = "deduction"
}
